var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"tw-mt-0 tw-mb-1 tw-mx-1 md:tw-ml-2 md:tw-mr-2"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }